import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent, EntityThemeTrackingProperties } from './types';

export const createChartEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackChartOpen = (
    source: PosthogTrackingSource,
    type?: string,
    additionalProperties: EntityThemeTrackingProperties = {}
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.CHART_OPEN,
      properties: {
        source,
        type,
        ...additionalProperties,
      },
    });

  return { trackChartOpen };
};
